<template>
  <div>
    <TheBuCommonHeaderSimple />
    <main class="pt-[4.375rem]">
      <slot />
    </main>
    <TheTeCommonBizFooter />
  </div>
</template>

<script setup lang="ts">
import TheBuCommonHeaderSimple from '~/components/Bu/BuCommon/Header/TheBuCommonHeaderSimple/TheBuCommonHeaderSimple.vue'
import TheTeCommonBizFooter from '~/components/Te/TeCommon/Footer/TheTeCommonBizFooter.vue'

useHead({
  htmlAttrs: {
    'data-theme': 'techacademy',
  },
})
</script>

